<template>
  <v-footer>
    <v-row justify="center" no-gutters>
<!--      <v-btn
          v-for="link in links"
          :key="link"
          class="mx-2"
          color=""
          rounded="xl"
          variant="text"
      >
        {{ link }}
      </v-btn>-->
      <v-col class="text-center mt-4" cols="12">
        &copy; {{ new Date().getFullYear() }} — <strong>X Fashion Market s.r.o.</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data: () => ({
    links: [
      'Domů',
      'O nás',
      'Služby',
      'Kontakty',
    ],
  }),
}
</script>
